<template>
  <div>
    <el-dialog
      :title="rowData.status === 'view' ? '品牌详情': rowData.status ==='edit' ? '编辑品牌' : '添加品牌'"
      :visible.sync="dialogVisible"
      width="width"
      :close-on-click-modal="false"
      :append-to-body="true"
      :before-close="dialogBeforeClose">
      <el-form label-width="110px" ref="ruleForm" :model="form" :rules="rules" :disabled="rowData.status==='view'">
       <el-form-item label="品牌名称" prop="brandName">
          <el-input
              :maxlength="32"
              v-model.trim="form.brandName"
              placeholder="中文名限中文、字母，32个字符，区分大小写">
            </el-input>
        </el-form-item>
        <el-form-item label="品牌英文名称" prop="brandEnName">
          <el-input
              :maxlength="32"
              v-model.trim="form.brandEnName"
              placeholder="字母、下划线，最多32个字符，区分大小写">
            </el-input>
        </el-form-item>
        <el-form-item label="品牌logo" prop="brandLogo">
          <el-upload
            :data="data"
            :show-file-list="false"
            :on-success="(res,file)=>{handleAvatarSuccess('logo',res,file)}"
            class="avatar-uploader"
            :before-upload="beforeLogoUp"
            action="/api/paas-platform/file-service/v1/file/upload/fileUpload"
            accept="image/png">
            <el-image
              v-if="logoUrl!==''"
              :src="logoUrl"
              class="avatar"
              :preview-src-list="rowData.status === 'view' ? [logoUrl] : []" />
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon"/>
          </el-upload>
          <span class="file_upload_img_des">图标要求格式.png,logo以外为透明,大小5M以内</span>
        </el-form-item>
        <el-form-item label="二维码" prop="qrCode">
          <!-- <uploadPicView  tipMes="图标要求格式.png .jpg .jpeg .gig .bmp,大小5M以内"/> -->
          <el-upload
            :data="data"
            :show-file-list="false"
            :on-success="(res,file)=>{handleAvatarSuccess('qrCode',res,file)}"
            class="avatar-uploader"
            :before-upload="beforeQRUp"
            action="/api/paas-platform/file-service/v1/file/upload/fileUpload"
            accept="image/png">
            <el-image
              v-if="qrCodeUrl!==''"
              :src="qrCodeUrl"
              class="avatar"
              :preview-src-list="rowData.status ==='view' ? [qrCodeUrl] : []" />
            <i
              v-else
              class="el-icon-plus avatar-uploader-icon"/>
          </el-upload>
          <span class="file_upload_img_des">图标要求格式.png .jpg .jpeg .gig .bmp,大小5M以内</span>
        </el-form-item>

        <el-form-item label="备注" prop="remarks">
          <el-input
            v-model="form.remarks"
            type="textarea"
            :maxlength="255"
            :rows="4"
            placeholder="请输入备注"
            >
          </el-input>
        </el-form-item>
     </el-form>
      <div slot="footer">
        <el-button @click="dialogBeforeClose" >{{ rowData.status === 'view'? '返回':'取 消'}}</el-button>
        <el-button type="primary" @click="confirm('ruleForm')" v-if="rowData.status !== 'view'">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { deleteImg } from '@/api/fileServer'
import { addBrand, brandDetail, editBrand } from '@/api/brand'
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    /* const qrCodeVer = (rule, value, callback) => {
      if (this.form.qrCode === '') {
        callback(new Error('请上传二维码'))
      } else {
        callback()
      }
    } */
    const logoVer = (rule, value, callback) => {
      if (this.form.brandLogo === '') {
        callback(new Error('请上传品牌logo'))
      } else {
        callback()
      }
    }
    const checkName = (rule, value, callback) => {
      const reg = /^[\u4e00-\u9fa5\-A-Za-z]{0,32}$/
      if (!reg.test(value)) {
        callback(new Error('请输入32位以内的中文、英文字符！'))
      } else {
        callback()
      }
    }
    const checkEnName = (rule, value, callback) => {
      const reg = /^[A-Za-z_]{0,32}$/
      if (!reg.test(value) && value !== '') {
        callback(new Error('请输入32位以内的英文字符、下划线！'))
      } else {
        callback()
      }
    }
    return {
      logoUrl: '', // 品牌logo图片
      qrCodeUrl: '', // 二维码图片
      data: {
        dir: 'category/addBrand/img'
      },
      allImgList: [],
      form: {
        brandName: '',
        brandEnName: '',
        brandLogo: '',
        qrCode: '',
        remarks: ''
      },
      rules: {
        brandName: [
          { required: true, message: '请输入品牌名称', trigger: 'blur' },
          { validator: checkName, trigger: 'blur' }
        ],
        brandEnName: [
          { validator: checkEnName, trigger: 'blur' }
        ],
        brandLogo: [
          { required: true, validator: logoVer, trigger: 'change' }
        ]
        /* qrCode: [
          { required: true, validator: qrCodeVer, trigger: 'change' }
        ], */
      }
    }
  },
  created () {
    console.log(this.rowData)
    if (this.rowData && this.rowData.status) {
      this.getBrandDetail()
    }
  },
  methods: {
    getBrandDetail () {
      const params = {
        params: this.rowData.brandId
      }
      brandDetail(params).then(res => {
        const result = res.data.data
        console.log(result)
        // 添加入图片处理数组中
        this.allImgList.push(result.brandLogo)
        this.allImgList.push(result.qrCode)
        // 数据回显
        this.logoUrl = result.logoUrl
        this.qrCodeUrl = result.qrUrl
        delete result.logoUrl
        delete result.qrUrl
        delete result.isDelete
        delete result.isEnable
        delete result.updateTime
        this.form = Object.assign({}, result)
      })
    },
    handleAvatarSuccess (obj, res, file) {
      // console.log(obj, res, file)
      if (res.code !== 200) {
        this.$message.error('上传出错，请重新上传')
        return
      }
      this.allImgList.push(res.data.pathKey)
      if (obj === 'qrCode') {
        this.qrCodeUrl = res.data.fileUrl
        this.form.qrCode = res.data.pathKey
      } else {
        this.logoUrl = res.data.fileUrl
        this.form.brandLogo = res.data.pathKey
      }
      /* this.fileList[obj].fileKey = res.data.pathKey
      this.fileList[obj].fileName = file.name */
    },
    dialogBeforeClose () {
      this.$emit('closeDialog')
    },
    confirm () {
      this.$refs.ruleForm.validate((valid) => {
        this.delImgList()
        if (valid) {
          const params = Object.assign({}, this.form)
          if (this.rowData.status !== 'edit') {
            addBrand({ params }).then(res => {
              if (res.data.code === 200) {
                this.$message({
                  type: 'success',
                  message: '添加成功'
                })
              }
              this.$emit('closeDialog', 1)
            })
          } else {
            params.brandId = this.rowData.brandId
            editBrand({ params }).then(res => {
              if (res.data.code === 200) {
                this.$message({
                  type: 'success',
                  message: '编辑成功'
                })
                this.$emit('closeDialog', 1)
              }
            })
          }
        } else {
          return false
        }
      })
    },
    // 删除图片接口
    delImgList () {
      const saveImgs = []
      saveImgs.push(this.form.brandLogo)
      saveImgs.push(this.form.qrCode)
      // 进行需要删除的图片处理操作
      const result = this.allImgList.filter((item) => {
        return saveImgs.indexOf(item) === -1
      })
      if (result.length > 0) {
        // TODO: 调用删除图片接口
        const params = Object.assign([], result)
        deleteImg({ params }).then((res) => {
          if (res.data.code === 200) {
            console.log('多余图片删除成功')
          }
        })
      }
    },
    beforeLogoUp (file) {
      if (file.type.split('/')[1] !== 'png') {
        this.$message.error('上传文件只能是图片格式！')
        return false
      }
      if (file.size / 1024 / 1024 >= 5) {
        this.$message.error('请上传5M以内的图片！')
        return false
      }
      return true
    },
    beforeQRUp (file) {
      if (file.type.split('/')[1] !== 'gig' && file.type.split('/')[1] !== 'bmp' && file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
        this.$message.error('上传文件只能是图片格式！')
        return false
      }
      if (file.size / 1024 / 1024 >= 5) {
        this.$message.error('请上传5M以内的图片！')
        return false
      }
      return true
    }
  }
}
</script>

<style lang='less' scoped>
.file_upload_img_des{
  color: #DCDFE6;
}
/deep/ .el-upload{
  border: 1px dashed #d9d9d9;
}
/deep/.avatar-uploader {
  width: 100px;
  height: 100px;
}
/deep/.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>
